exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.ErrorText-Error_6R26X {\n  margin-top: 0.25rem;\n  color: #a53d46; }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/ErrorText/ErrorText.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,eAAe,EAAE","file":"ErrorText.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.Error {\n  margin-top: 0.25rem;\n  color: #a53d46; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"Error": "ErrorText-Error_6R26X"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/ErrorText/ErrorText.scss
// module id = 1308
// module chunks = 0